import { __decorate } from "tslib";
import { ChangeDetectorRef, Component, EventEmitter, HostListener, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { SharedHttp } from '../../services/http-client.service';
import { AuthService } from '../../services/auth.service';
import { PaymentService } from '../../services/payment.service';
import { DomSanitizer } from '@angular/platform-browser';
import { EcurrenciesService } from '../../services/ecurrencies.service';
import { WebsiteThemeService } from '../../services/website-theme.service';
import { ActivatedRoute } from '@angular/router';
/**
 * Dropdown Component
 */
let CurrenciesDropdownComponent = class CurrenciesDropdownComponent {
    constructor(httpClient, auth, paymentService, sanitizer, ecurrenciesService, changeDetector, themeService, route) {
        this.httpClient = httpClient;
        this.auth = auth;
        this.paymentService = paymentService;
        this.sanitizer = sanitizer;
        this.ecurrenciesService = ecurrenciesService;
        this.changeDetector = changeDetector;
        this.themeService = themeService;
        this.route = route;
        this.borderRadiusSmaller = '';
        this.showCurrency = false;
        this.inputBackColor = '';
        this.textColor = '';
        this.setCur = new EventEmitter();
        this.themeService.getTheme().subscribe((data) => {
            this.textColor = this.themeService.getStyleAttribute('text_color');
            this.borderRadiusSmaller = this.themeService.getStyleAttribute('border_radius_smaller');
            this.inputBackColor = this.themeService.getStyleAttribute('input_background_color');
        });
    }
    ngOnInit() {
    }
    clickCurrency() {
        this.showCurrency = !this.showCurrency;
    }
    onDocumentClick(event) {
        const targetElement = event.target;
        if (targetElement.className !== 'currencySelected' &&
            targetElement.className !== 'currencySelectOptions' &&
            targetElement.className !== 'currencySelect') {
            this.closeCurrency();
        }
    }
    closeCurrency() {
        this.showCurrency = false;
    }
    setCurrency(curCode) {
        this.currency = curCode;
        this.setCur.emit(curCode);
    }
};
CurrenciesDropdownComponent.ctorParameters = () => [
    { type: SharedHttp },
    { type: AuthService },
    { type: PaymentService },
    { type: DomSanitizer },
    { type: EcurrenciesService },
    { type: ChangeDetectorRef },
    { type: WebsiteThemeService },
    { type: ActivatedRoute }
];
__decorate([
    Input()
], CurrenciesDropdownComponent.prototype, "ecurrencies", void 0);
__decorate([
    Input()
], CurrenciesDropdownComponent.prototype, "currency", void 0);
__decorate([
    Input()
], CurrenciesDropdownComponent.prototype, "formDesign", void 0);
__decorate([
    Input()
], CurrenciesDropdownComponent.prototype, "source", void 0);
__decorate([
    Output("setCur")
], CurrenciesDropdownComponent.prototype, "setCur", void 0);
__decorate([
    HostListener('document:click', ['$event'])
], CurrenciesDropdownComponent.prototype, "onDocumentClick", null);
CurrenciesDropdownComponent = __decorate([
    Component({
        selector: 'ecd-currencies-dropdown',
        encapsulation: ViewEncapsulation.None,
        template: __importDefault(require("./currencies-dropdown.component.html")).default
    })
], CurrenciesDropdownComponent);
export { CurrenciesDropdownComponent };
